import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-group form-group-text text-left p-float-label mt-2 w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "E-mail", -1)
const _hoisted_4 = { class: "form-group form-group-text text-left p-float-label mt-8 w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "e-mail",
  class: "font-weight-bold"
}, "Senha", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "form-group form-group-text text-left p-float-label mt-2 w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "E-mail", -1)
const _hoisted_9 = {
  key: 0,
  class: "text-red-500"
}

import BaseInput from "./BaseInput.vue";
import FormWrapper from "./FormWrapper.vue";

import { ref } from "vue";
import type { Ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  props: {
  isLogging: Boolean,
},
  setup(__props) {

const props = __props;

const router = useRouter();


const store = useStore();

const form: Ref = ref({
  login: "",
  password: "",
});

const isEmailValid: Ref<boolean> = ref(true);

const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const handleSubmit = (e: any) => {
  e.preventDefault();
  isEmailValid.value = validateEmail(form.value.login);

  if (!props.isLogging && !isEmailValid.value) {
    return;
  }

  const action = props.isLogging ? "LOGIN_USER" : "SEND_EMAIL_CHANGE_PASSWORD";
  console.log(form.value);
  store
    .dispatch(action, form.value)
    .then((r) => {
      if (props.isLogging && !(r instanceof Error) && r) {
        router.push({ path: "/home" });
      }
    })
    .catch();
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createBlock(FormWrapper, { onSubmit: handleSubmit }, {
    content: _withCtx(() => [
      (__props.isLogging)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InputText, {
                name: "email",
                "aria-describedby": "culture-name-help",
                modelValue: form.value.login,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.login) = $event)),
                class: _normalizeClass(`w-full`),
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Password, {
                class: "password w-full",
                modelValue: form.value.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
                toggleMask: "",
                feedback: false
              }, null, 8, ["modelValue"]),
              _hoisted_5
            ])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InputText, {
                name: "email",
                "aria-describedby": "culture-name-help",
                modelValue: form.value.login,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.login) = $event)),
                class: _normalizeClass(`w-full`),
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_8,
              (!isEmailValid.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_9, "E-mail inválido"))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    buttons: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})